module.exports = __webpack_public_path__ + "media/global_smart_banner/gsb-app-icon-3a478777.svg";